import { Stack, Typography } from '@mui/material';
import { ServiceProps } from 'src/@types/service';
import ProjectRelatedServiceItem from './ProjectRelatedServiceItem';

type Props = {
  services: ServiceProps[];
};

const ProjectRelatedServices: React.FC<Props> = ({ services }) => {
  return (
    <>
      <Typography variant="h5" mb={3}>
        Relaterte tjenester
      </Typography>
      <Stack spacing={2}>
        {services.map((service) => (
          <ProjectRelatedServiceItem key={service._id} service={service} onSiderbar />
        ))}
      </Stack>
    </>
  );
};

export default ProjectRelatedServices;
